import React from 'react';
import { JobStatus } from '../../types/api';

interface Props {
  status: JobStatus | string;
}

const StatusBadge: React.FC<Props> = ({ status }) => {
  const normalized = status as JobStatus;
  return (
    <span className={`status-badge status-${normalized}`}>
      {status.replace('_', ' ')}
    </span>
  );
};

export default StatusBadge;

